
import { DocumentContentEditor } from "./DocumentContentEditor";

interface StrategicPlanViewProps {
  content: any;
  documentId: string;
  onUpdate: () => void;
}

export function StrategicPlanView({ content, documentId, onUpdate }: StrategicPlanViewProps) {
  const isEmpty = (text: string) => !text || text.trim() === '';
  const sections = [
    { key: 'executiveSummary', title: 'Executive Summary', content: content.executiveSummary },
    { key: 'missionStatement', title: 'Mission Statement', content: content.missionStatement },
    { key: 'visionStatement', title: 'Vision Statement', content: content.visionStatement },
    { key: 'strategicGoals', title: 'Strategic Goals', content: content.strategicGoals }
  ];
  
  const firstEmptyIndex = sections.findIndex(section => isEmpty(section.content));

  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Executive Summary</h2>
        <DocumentContentEditor
          section="Executive Summary"
          content={content.executiveSummary}
          documentId={documentId}
          field="executiveSummary"
          onUpdate={onUpdate}
          showHint={firstEmptyIndex === 0}
        />
      </section>
      
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Mission & Vision</h2>
        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-medium mb-2">Mission Statement</h3>
            <DocumentContentEditor
              section="Mission Statement"
              content={content.missionStatement}
              documentId={documentId}
              field="missionStatement"
              onUpdate={onUpdate}
              showHint={firstEmptyIndex === 1}
            />
          </div>
          <div>
            <h3 className="text-xl font-medium mb-2">Vision Statement</h3>
            <DocumentContentEditor
              section="Vision Statement"
              content={content.visionStatement}
              documentId={documentId}
              field="visionStatement"
              onUpdate={onUpdate}
              showHint={firstEmptyIndex === 2}
            />
          </div>
        </div>
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Strategic Goals</h2>
        <DocumentContentEditor
          section="Strategic Goals"
          content={content.strategicGoals}
          documentId={documentId}
          field="strategicGoals"
          onUpdate={onUpdate}
          showHint={firstEmptyIndex === 3}
        />
      </section>
    </div>
  );
}
